import { useState } from 'react';
import { useQuery } from 'react-query';
import { endpoints, fetcher } from 'services';

const useLectureCode = () => {
  /* ======================================================
   * state
   * ====================================================== */
  const [lectureCodeList, setLectureCodeList] = useState<LectureCodeListDto[] | any[]>();
  
  /* ======================================================
   * hooks
   * ====================================================== */

  const { isLoading } = useQuery(
    [endpoints.refcode.lecture.codelist],
    () => fetcher.refcode.getLectureCodeList(),
    {
      onSuccess: (res: LectureCodeListResDto) => {
        switch (res.code) {
          case 200:
            setLectureCodeList(res.result?.list);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  return { isLoading, lectureCodeList };
};

export default useLectureCode;
